import _ from 'lodash';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import EstatePlanService from './EstatePlanService';

import { Answers } from 'types/zod/answers';
import { type RemainingSteps } from 'types/zod/remaining-steps';

const RemainingStepsService = {
    saveNewRemainingSteps: async (qInstanceId: number, hiddenAnswers: Answers) => {
        hiddenAnswers.finalization = _.pickBy(hiddenAnswers.finalization, (value: any) => value !== false);
        return await $$api.answers.putAnswersFx({ id: qInstanceId, answers: hiddenAnswers, path: 'hidden' });
    },

    setOption: async (stepName: RemainingSteps, value: boolean) => {
        const qInstanceId = EstatePlanService.getQInstanceId();
        if (!qInstanceId) {
            return;
        }
        const hiddenAnswers = $global.map((state) => state.answers?.[qInstanceId]?.hidden || {}).getState();

        if (!hiddenAnswers.finalization) {
            hiddenAnswers.finalization = {};
        }

        hiddenAnswers.finalization[stepName] = value;

        if (stepName === 'signed') {
            hiddenAnswers.last_signed_date = '' + Date.now();
        }

        await RemainingStepsService.saveNewRemainingSteps(qInstanceId, hiddenAnswers);
    },

    completeStep: async (stepName: RemainingSteps) => {
        return await RemainingStepsService.setOption(stepName, true);
    },

    resetStep: async (stepName: RemainingSteps) => {
        return await RemainingStepsService.setOption(stepName, false);
    },
};

export default RemainingStepsService;
